import React, { useState } from 'react';
import { Text } from '@react-pdf/renderer';
import compose from '../styles/compose';

export default function EditableSelect({ className, options, placeholder, value, onChange, pdfMode, disabled }) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      {pdfMode ? (
        <Text style={compose('span ' + (className ? className : ''))}>{value}</Text>
      ) : (
        <select
          className={'select ' + (className ? className : '')}
          value={value} // Ensure this matches an option's value
          onChange={onChange ? (e) => onChange(e.target.value) : undefined}
          onBlur={() => setIsEditing(false)}
          autoFocus={true}
          disabled={disabled}

        >
          {options?.map((option) => (
            <option key={option.value} value={option.text}> {/* Use option.value instead of option.placeholder */}
              {option.text}
            </option>
          ))}
        </select>
      )}
    </>
  );
};
